<template>
    <div class="clinic-supporting-document-uploader">
        <form ref="formUploader" @submit.prevent="validateFileAndUpload">
            <div class="form-group">
                <div>
                    <input ref="uploadFileInput" type="file" v-validate="'required'"
                        :data-vv-as="uploadFileName" name="fileInput"
                        :class="{'is-invalid': validationErrors.has('fileInput')}">
                    <div v-show="validationErrors.has('fileInput')" class="invalid-feedback">
                        {{ validationErrors.first('fileInput') }}
                    </div>
                </div>
            </div>
            <div>
                <p v-show="isUploading" :class="{
                    'text-danger': isUploadingError,
                    'mb-3': true
                }">
                    {{ uploadMessage }}
                </p>
            </div>
            <div>
                <button class="btn btn-primary btn-primary-insv" type="submit">{{ uploadButtonText }}</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'ClinicSupportingDocumentUploader',
    'props': {
        'uploadButtonText': {
            'type': String,
            'default': 'Upload File'
        },
        'uploadFileName': {
            'type': String,
            'default': 'document'
        },
        'uploadApiUrl': {
            'type': String,
            'required': true
        },
        'uploadApiFileParameter': {
            'type': String,
            'required': true
        },
        'uploadApiAdditionalParameters': {
            'type': Array,
            default () {
                return []; // [{name:xxx, value: yyy'}]
            }
        }
    },
    data () {
        return {
            'isUploading': false,
            'isUploadingError': false,
            'uploadMessage': ''

        };
    },
    'methods': {
        validateFileAndUpload () {
            this.isUploading = true;
            this.isUploadingError = false;

            this.$validator.validateAll().then((isFormValid) => {
                if (isFormValid) {
                    let selectedFileToUpload = this.$refs.uploadFileInput.files[0];

                    let formData = new FormData();
                    formData.append(this.uploadApiFileParameter, selectedFileToUpload);
                    this.uploadApiAdditionalParameters.forEach((param) => {
                        formData.append(param.name, param.value);
                    });

                    this.uploadMessage = `Uploading ${this.uploadFileName} document file...`;

                    this.axios.post(this.uploadApiUrl, formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({
                        data
                    }) => {
                        this.$refs.formUploader.reset();

                        if (data.data && data.data.fg) {
                            this.uploadMessage = `${this.uploadFileName} document updated successfully!`;
                            this.$emit('fileUploaded', {
                                'fileNameGuid': data.data.fg,
                                'fileName': data.data.fn
                            });
                        } else {
                            this.isUploadingError = true;
                            this.uploadMessage = data.data.e;
                        }
                    }).catch((error) => {
                        this.isUploadingError = true;
                        if (error && error.response && error.response.data) {
                            this.uploadMessage = error.response.data.message;
                        } else {
                            this.uploadMessage = `Error processing ${this.uploadFileName} document upload. Please try again.`;
                        }
                    });
                } else {
                    this.isUploadingError = true;
                    this.uploadMessage = `You have error in the form. Please check your input(s) before saving your ${this.uploadFileName} document.`;
                }
            });
        }
    }
};
</script>
